import React from "react";
import { useTranslation } from "react-i18next";
import PageHeaderSolutions from "../components/PageHeaderSolutions";
import { CaretRightFilled } from "@ant-design/icons";
import SecurityBanner from "../appareas/SecurityBanner";
import FraudDetectionDataset from "./charts/FraudDetectionDataset"
import FraudDetectionModel from "./charts/FraudDetectionModel"


const FraudDetection = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageHeaderSolutions></PageHeaderSolutions>
      <section className="mt-24 w-full h-full relative bg-center bg-cover p-5 border-2 border-blue-900 rounded-lg bg-white">
        <div> <SecurityBanner></SecurityBanner> </div>
        <div className="items-center text-center">
          <h3 className="mt-2 text-blue-900 text-4xl font-semibold mb-2">
            {t("fraud_detection")}
          </h3>
        </div>

        <p className="text-2xl">
          <CaretRightFilled />
          {t("fraud_detection_description1")}
        </p>

        <FraudDetectionDataset></FraudDetectionDataset>
        <FraudDetectionModel></FraudDetectionModel>

      </section>
    </>
  );
};

export default FraudDetection;
